<template>
    <div class="row fix-height-not-mobile">
        <div class="col-sm-2 col-xs-4">
            <customer-title></customer-title>
        </div>
        <div class="col-sm-5 col-xs-8">
            <customer-first-name></customer-first-name>
        </div>
        <div class="col-sm-5 col-xs-12">
            <customer-last-name></customer-last-name>
        </div>
    </div>
</template>

<script>
export default {

}
</script>